import React from "react";
import { Redirect, Route, Switch } from "react-router";
import CandidateLanding from "./CandidateLanding/CandidateLanding";
import "./landing-page.style.scss";
import LandingHeader from "./LandingHeader/LandingHeader";
import InstitutionLanding from "./InstitutionLanding/InstitutionLanding";
export default function LandingPage() {
  const [headerOpacity, setHeaderOpacity] = React.useState(false);
  const scrollRefLanding = React.useRef();
  const [candidateLanding, setCandidateLanding] = React.useState(true);
  const handleScroll = () => {
    if (scrollRefLanding.current.scrollTop > window.innerHeight) {
      setHeaderOpacity("opaque");
    } else if (scrollRefLanding.current.scrollTop > window.innerHeight / 4) {
      setHeaderOpacity("opaque");
    } else {
      setHeaderOpacity("");
    }
  };
  const mainRef = React.useRef();

  React.useEffect(() => {
    scrollRefLanding.current.scroll({ top: 0 });
  }, [candidateLanding]);

  return (
    <div
      mainRef={mainRef}
      onScroll={handleScroll}
      ref={scrollRefLanding}
      className="landing-page-main"
    >
      <LandingHeader
        opaque={headerOpacity}
        candidateLanding={candidateLanding}
      />
      <Switch>
        <Route
          path="/candidate"
          render={() => (
            <CandidateLanding
              initial={() => {
                mainRef?.current?.scroll({ top: 0 });
                setCandidateLanding(true);
              }}
            />
          )}
        />
        <Route
          path="/institution"
          render={() => (
            <InstitutionLanding
              initial={() => {
                mainRef?.current?.scroll({ top: 0 });
                setCandidateLanding(false);
              }}
            />
          )}
        />
        <Redirect to="/candidate" />
      </Switch>
    </div>
  );
}
